// extracted by mini-css-extract-plugin
export default {"box_btn":"style_box_btn__YE9sG","selected":"style_selected__K1Liu","rowSelected":"style_rowSelected__cQwfP"};